import styled from 'styled-components'
import { containerExpanded } from '../../lib/styles/Container'
import { typoHeading2, typoParagraph } from '../../lib/styles/Typography'

import { StyledButton } from '../../components/UI/Button/styled'

export const StyledWrapper = styled.div`
  ${containerExpanded}
  margin: 3rem auto;
`

export const StyledDisturber = styled.div`
  align-items: center;
  background-color: var(--c-theme-3);
  border-radius: 1.5rem;
  color: var(--c-theme-invert);
  display: flex;
  flex: 1 1 auto;
  gap: 3rem;
  padding: 4rem;

  @media screen and (max-width: 992px) {
    padding: 3rem;
  }

  @media screen and (max-width: 860px) {
    align-items: unset;
    flex-direction: column;
    gap: 0.5rem;
  }

  @media screen and (max-width: 480px) {
    padding: 2rem;
  }
`

export const StyledHeader = styled.div`
  flex: 0;
`

export const StyledBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  max-width: 32rem;
`

export const StyledHeadline = styled.h2`
  ${typoHeading2}
`

export const StyledDescription = styled.div`
  ${typoParagraph}
`

export const StyledForm = styled.form`
  max-width: 20rem;
  position: relative;

  ${StyledButton} {
    position: absolute;
    right: 0.4rem;
    top: 50%;
    transform: translateY(-50%);
  }
`

export const StyledInput = styled.div`
  position: relative;
`

export const StyledSuccessMessage = styled.p`
  white-space: pre-line;
`

export const StyledErrorMessage = styled.p`
  color: ${({ theme }) => theme.colors.red[4]};
  font-size: 0.7rem;
  font-weight: 600;
  margin-top: 0.6rem;
  padding-left: 0.6rem;
`
